import { render, staticRenderFns } from "./MediaManagementV2.vue?vue&type=template&id=771878ef&scoped=true"
import script from "./MediaManagementV2.vue?vue&type=script&lang=js"
export * from "./MediaManagementV2.vue?vue&type=script&lang=js"
import style0 from "./MediaManagementV2.vue?vue&type=style&index=0&id=771878ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771878ef",
  null
  
)

export default component.exports